import { InspectionStatusEnum } from '@program-suite/data-common/program';

export const STATUS_LABELS: Record<InspectionStatusEnum, string> = {
  [InspectionStatusEnum.Pending]: 'Pending',
  [InspectionStatusEnum.FirstNotice]: 'First Notice',
  [InspectionStatusEnum.SecondNotice]: 'Second Notice',
  [InspectionStatusEnum.ThirdNotice]: 'Third Notice',
  [InspectionStatusEnum.FinalInspectionNotice]: 'Final Inspection Notice',
  [InspectionStatusEnum.NoticeOfCancellation]: 'NOC',
  [InspectionStatusEnum.FinalNotice]: 'Final Notice',
  [InspectionStatusEnum.Expired]: 'Expired',
  [InspectionStatusEnum.Complete]: 'Complete',
  [InspectionStatusEnum.Cancelled]: 'Canceled',
};
